class HpSeoText extends HTMLElement {
  connectedCallback() {
    this.contentWrap = this.querySelector(".hp-seo-text__content-wrap");
    this.toggleButton = this.querySelector(".hp-seo-text__toggle");
    this.toggleLabel = this.querySelector(".hp-seo-text__toggle-label");

    if (!this.contentWrap || !this.toggleButton) {
      return;
    }

    this.moreLabel = this.toggleButton.dataset.labelMore || "";
    this.lessLabel = this.toggleButton.dataset.labelLess || "";
    this.collapsedHeight = this.getCollapsedHeight();
    this.isAnimating = false;

    this.onTransitionEnd = this.onTransitionEnd.bind(this);
    this.contentWrap.addEventListener("transitionend", this.onTransitionEnd);

    this.updateCollapsibleState();
    this.toggleButton.addEventListener("click", this.onToggle.bind(this));

    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => this.updateCollapsibleState());
      this.resizeObserver.observe(this.contentWrap);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.contentWrap?.removeEventListener("transitionend", this.onTransitionEnd);
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  getCollapsedHeight() {
    const section = this.closest("[id^='shopify-section-']");
    const value = getComputedStyle(section || this).getPropertyValue("--hp-seo-collapsed-height").trim();
    const parsed = parseFloat(value);

    return Number.isFinite(parsed) ? parsed : 120;
  }

  updateCollapsibleState() {
    if (this.isAnimating) {
      return;
    }

    this.collapsedHeight = this.getCollapsedHeight();

    const contentHeight = this.contentWrap.scrollHeight;
    const isCollapsible = contentHeight > this.collapsedHeight + 8;

    this.classList.toggle("is-collapsible", isCollapsible);

    if (!isCollapsible) {
      this.collapse(false);
      return;
    }

    if (this.classList.contains("is-expanded")) {
      this.contentWrap.style.maxHeight = `${contentHeight}px`;
    } else {
      this.contentWrap.style.maxHeight = "";
    }
  }

  onToggle() {
    if (this.isAnimating) {
      return;
    }

    if (this.classList.contains("is-expanded")) {
      this.collapse(true);
      return;
    }

    this.expand();
  }

  expand() {
    const targetHeight = this.contentWrap.scrollHeight;
    const collapsedHeight = this.collapsedHeight;

    this.classList.add("is-expanded");
    this.toggleButton.setAttribute("aria-expanded", "true");
    this.toggleLabel.textContent = this.lessLabel;

    if (this.prefersReducedMotion) {
      this.contentWrap.style.maxHeight = `${targetHeight}px`;
      return;
    }

    this.isAnimating = true;
    this.classList.add("is-animating");
    this.contentWrap.style.maxHeight = `${collapsedHeight}px`;
    this.contentWrap.offsetHeight;
    this.contentWrap.style.maxHeight = `${targetHeight}px`;
  }

  collapse(animate) {
    const collapsedHeight = this.collapsedHeight;

    this.classList.remove("is-expanded");
    this.toggleButton.setAttribute("aria-expanded", "false");
    this.toggleLabel.textContent = this.moreLabel;

    if (!animate || this.prefersReducedMotion) {
      this.contentWrap.style.maxHeight = "";
      this.isAnimating = false;
      this.classList.remove("is-animating");
      return;
    }

    this.isAnimating = true;
    this.classList.add("is-animating");
    this.contentWrap.style.maxHeight = `${this.contentWrap.scrollHeight}px`;
    this.contentWrap.offsetHeight;
    this.contentWrap.style.maxHeight = `${collapsedHeight}px`;
  }

  onTransitionEnd(event) {
    if (event.propertyName !== "max-height" || event.target !== this.contentWrap) {
      return;
    }

    this.isAnimating = false;
    this.classList.remove("is-animating");

    if (this.classList.contains("is-expanded")) {
      this.contentWrap.style.maxHeight = `${this.contentWrap.scrollHeight}px`;
      return;
    }

    this.contentWrap.style.maxHeight = "";
  }
}

if (!window.customElements.get("hp-seo-text")) {
  window.customElements.define("hp-seo-text", HpSeoText);
}
